import React from 'react';
import Button from '../ui/Button';
import { useTranslation } from 'react-i18next';

interface FunnelHeroProps {
    headline: string;
    subheadline: string;
    imageUrl: string;
}

const FunnelHero: React.FC<FunnelHeroProps> = ({ headline, subheadline, imageUrl }) => {
    const { t } = useTranslation('common');
    return (
        <div className="relative overflow-hidden pt-32 pb-24 text-center">
            <div className="absolute inset-0">
                <img src={imageUrl} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-20" width="1600" height="900" loading="lazy"/>
                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/80 to-transparent"></div>
            </div>
            <div className="relative z-10 mx-auto max-w-4xl px-6">
                <h1
                    className="text-4xl md:text-6xl font-serif font-bold tracking-tight text-balance"
                >
                    {headline}
                </h1>
                <p
                    className="mt-6 text-xl text-white max-w-3xl mx-auto text-balance"
                >
                    {subheadline}
                </p>
                <div
                    className="mt-10"
                >
                    <Button to="/contact" variant="primary" className="px-8 py-4 text-lg">
                        {t('aboutPage.ctaButton')}
                    </Button>
                    <p className="mt-3 text-sm text-white/70">{t('aboutPage.ctaDisclaimer')}</p>
                </div>
            </div>
        </div>
    );
};

export default FunnelHero;